// extracted by mini-css-extract-plugin
export default {"main":"Notifications_main__fyW8d","container":"Notifications_container__zk404"};